
<div class="container bg-white">
    <div class="row pt-2 pb-0">
        <div class="col-7 cursor outline-0 mt-0" [routerLink]="['/home']">
            <div class="logo-background"></div>
        </div>
    </div>
    <div class="row mt-0 pt-0">
        <h6 class="text-center pl-2" style="padding: 65px; margin-left: 5%"></h6>
    </div>
</div>
<div class="row mt-5" *ngIf="linkExpired">
    <div class="col text-center">
        <div>
            <label for="" class="h3">Your link expired!!</label>
        </div>
        <a class="cursor text-primary" [routerLink]="['/home']">Click here to go home</a>
    </div>
</div>